
const profileSchema = () => {
  return {
    first_name: {
      presence: {
        allowEmpty: false,
        message: '^لطفا نام خود را وارد کنید'
      },
      length: {
        maximum: 20,
        message: '^نام حداکثر می‌تواند ۲۰ کاراکتر باشد.'
      }
    },
    last_name: {
      presence: {
        allowEmpty: false,
        message: '^لطفا نام خانوادگی خود را وارد کنید.'
      },
      length: {
        maximum: 20,
        message: '^نام خانوادگی حداکثر می‌تواند ۲۰ کاراکتر باشد.'
      }
    }
  }
}

export default profileSchema
